export default {"src":"/_next/static/media/exclamation-bubble-orange.7e9578a9.svg","height":16,"width":15,"blurWidth":0,"blurHeight":0};